import script from './scrollbar.vue_vue_type_script_lang.mjs';
export { default } from './scrollbar.vue_vue_type_script_lang.mjs';
import { render } from './scrollbar.vue_vue_type_template_id_303f965d_lang.mjs';

script.render = render;
script.__file = "packages/components/scrollbar/src/scrollbar.vue";
//# sourceMappingURL=scrollbar2.mjs.map
